export const timeZoneCurrencyMap: { [key: string]: string } = {
  'America/New_York': 'USD', // United States Dollar
  'Europe/London': 'GBP', // British Pound
  'Asia/Tokyo': 'JPY', // Japanese Yen
  'Asia/Colombo': 'Rs', // Sri Lankan Rupee
  'Asia/Kolkata': 'INR', // Indian Rupee
};
